module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('widget-dialog', {
    attrs: {
      "bus": _vm.bus
    },
    on: {
      "cancel": _vm.dialogCancelled,
      "submit": _vm.dialogSubmitted
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "widgets"
  }, [_c('ul', {
    staticClass: "widgets__list"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.widgets.length === 0),
      expression: "widgets.length === 0"
    }],
    staticClass: "widgets__list--empty"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.lessDetails),
      expression: "!lessDetails"
    }]
  }, [_vm._v("\n                        Zawsze w szczegółach wyświetla się zdjęcie i opis. Wykorzystaj widgety, by dodać więcej informacji."), _c('br')]), _vm._v("\n                    Wybierz widget z listy po prawej stronie.\n                ")]), _vm._v(" "), _vm._l((_vm.widgets), function(widget, i) {
    return _c('li', {
      staticClass: "widget",
      class: {
        'widget--error': _vm.errors[i] && Object.keys(_vm.errors[i]).length > 0
      },
      on: {
        "click": function($event) {
          return _vm.editWidget(widget, _vm.errors[i])
        }
      }
    }, [_c('div', {
      staticClass: "buttons"
    }, [(i !== _vm.widgets.length - 1) ? _c('el-button', {
      attrs: {
        "size": "small",
        "title": "Przesuń w dół"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.changeOrder(_vm.widgets, i, 1)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-down"
    })]) : _vm._e(), _vm._v(" "), _c('el-button', {
      style: ({
        opacity: i !== 0 ? 1 : 0
      }),
      attrs: {
        "size": "small",
        "title": "Przesuń do góry"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.changeOrder(_vm.widgets, i, -1)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-up"
    })]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "small"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeWidget(widget, i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })])], 1), _vm._v(" "), _c('strong', [_vm._v(_vm._s(widget.name_pl || 'Widget bez nazwy'))]), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.getLabel(widget.resourcetype)))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "types"
  }, [_c('ul', {
    staticClass: "types__list"
  }, _vm._l((_vm.$store.state.idBasedWidgetTypes), function(type, key) {
    return _c('li', {
      staticClass: "type",
      on: {
        "click": function($event) {
          return _vm.addWidget(type)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-circle"
    }), _vm._v("\n                    " + _vm._s(type.label) + "\n                    "), _c('div', [_c('img', {
      staticClass: "widget__icon",
      attrs: {
        "src": ("/static/widgets/icons/" + (type.resourcetype) + ".png"),
        "alt": ""
      },
      on: {
        "error": function($event) {
          return _vm.iconLoadError(type.resourcetype)
        }
      }
    })])])
  }), 0)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a1b89f5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/WidgetsInput.vue
// module id = 748
// module chunks = 0